export const transparentWhite = "rgba(255,255,255,0)";